export default "__VITE_ASSET__Cv0BlYb1__"